import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    padding: "space60",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "colorBackgroundOffline",
    textAlign: "center"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize30",
    fontFamily: "fontFamilyText",
    fontWeight: "fontWeightBold"
};

export const textStyles: TextStyleProps = {
    marginBottom: "space50",
    marginTop: "space50"
};

export const buttonOkStyles: BoxStyleProps = {
    marginX: "auto",
    backgroundColor: "colorBackgroundPrimary",
    color: "colorTextLink",
    padding: "space40",
    borderColor: "colorBorderPrimary",
    boxShadow: "none",
    borderRadius: "borderRadius20",
    _hover: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        borderColor: "colorBorderPrimaryWeak",
        boxShadow: "none"
    }
};
